import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from "@emotion/react";
import { styled } from "../../theme";
export const BlockSlide = ({ darkBackground, verticalContentAlignment, className, children }) => (_jsxs(Wrapper, { darkBackground: darkBackground, className: className, children: [verticalContentAlignment !== "top" && (_jsx(Spacer, { verticalContentAlignment: verticalContentAlignment })), children, verticalContentAlignment !== "bottom" && (_jsx(Spacer, { verticalContentAlignment: verticalContentAlignment }))] }));
const Spacer = styled.div `
  ${({ verticalContentAlignment }) => ["bottom", "center"].includes(verticalContentAlignment) &&
    css `
      margin-top: auto;
    `}
  ${({ verticalContentAlignment }) => ["top", "center"].includes(verticalContentAlignment) &&
    css `
      margin-bottom: auto;
    `}
`;
/**
 * Use this class on slide's children text elements which should change color based on slide background.
 */
export const ADAPTABLE_TEXT_CLASSNAME = "page-appearance-adaptable-text";
const Wrapper = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  color: inherit;

  & .${ADAPTABLE_TEXT_CLASSNAME} {
    color: inherit;
    overflow-wrap: break-word;
    word-break: break-word;
    width: 100%;
  }

  ${({ darkBackground }) => darkBackground &&
    css `
      & .${ADAPTABLE_TEXT_CLASSNAME} {
        color: white;
      }
    `}
`;
